import React, { Component } from 'react';
import Data from '../../_core/models/Data';
import Image from '../../_core/components/Image';
import Link from '../../_core/components/Link';
import Icon from '../../_core/components/Icon';
import Content from '../../_core/components/Content';

let placeholder = {

	next : <Icon glyph type={'arrow-right'} />,
	prev : <Icon glyph type={'arrow-left'} />,
	close : <Icon glyph type={'plus'} />,
	total : 1,
	captions:[]
}

class LightBox extends Component {



  constructor(props){

      super(props);
      this.state = {progress:0};
  }

  componentDidMount = () => {

      const _this = this;

  }



  render() {    

   	let props = {...placeholder,...this.props};

    return (
        	
			<Data>
				{
					({SHOWIMAGE,IMAGE}) => {

						if(IMAGE){

							IMAGE = parseInt(IMAGE);

							return (
								<div className={`LightBox LightBox--${(SHOWIMAGE) ? 'active' : 'inactive'}`}>
								<div className="LightBox-content">
									
									<div className="LightBox-image">
										<Image src={`/ui/img/cgi/${IMAGE}.jpg`} fluid={true} />
									</div>

									<div className="LightBox-caption">
										<Content modifier="legal">
											<p>{props.captions[IMAGE-1]}</p>
										</Content>
									</div>

									<Link className="LightBox-prev" to={`#/image/${((IMAGE > 1) ? (IMAGE - 1) : props.total)}/`}>{props.prev}</Link>
									<Link className="LightBox-next" to={`#/image/${((IMAGE < props.total) ? (IMAGE + 1) : 1)}/`}>{props.next}</Link>
									<Link className="LightBox-close" to={`#/back`}>{props.close}</Link>
								</div>
								</div>
							)
						}else{
							return <div className={`LightBox LightBox--inactive`} />;
						}

					}
				}
			</Data>
				
    
    );
  }
}



export default LightBox;



// WEBPACK FOOTER //
// ./src/js/components/_interactions/InteractiveLightbox.js